import { websiteEnv } from '@/constants/website-env';
import { Tooltip } from 'antd';
import clsx from 'clsx';
import Link from 'next/link';
const CustomizeOptions = ({
  colorOptions,
  allColorCount,
  selectedShowColorIndex,
  setSelectedShowColorIndex,
  generateLinkByColorLabel,
}) => {
  const handleClick = index => {
    setSelectedShowColorIndex(index);
  };

  return (
    <div className='flex items-center gap-x-2 lg_gap-x-2.5'>
      <ul className='flex items-center gap-x-2 lg_gap-x-[5px]'>
        {colorOptions.map((value, index) => {
          const { rgb } = value;

          const blockStyle = /^#\S+$/.test(rgb)
            ? {
                backgroundColor: rgb,
              }
            : {
                backgroundImage: `url(${process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL_IMAGE}media/attribute/swatch/swatch_thumb/110x90${rgb})`,
                backgroundRepeat: 'no-repeat',
              };

          const isSelected = selectedShowColorIndex === index;
          const className = clsx(
            'block h-[18px] w-[18px] lg_h-5 lg_w-5',
            'border-1 border-solid',
            isSelected ? 'border-80583F p-[1px] lg_p-0.5 relative' : 'border-[#eee]',
            'rounded-[50%] ',
            'bg-contain bg-clip-content',
          );

          return (
            <Tooltip
              key={index}
              title={websiteEnv.isUnitedKingdom && value.label === 'Multi Color' ? 'Multicolour' : value.label}
            >
              {typeof generateLinkByColorLabel === 'function' ? (
                <li key={index}>
                  <Link
                    className={className}
                    onClick={e => {
                      e.preventDefault();
                      handleClick(index);
                    }}
                    href={generateLinkByColorLabel(value.label, value.is_change_url, value.fabric) || '#'}
                    style={blockStyle}
                    aria-label={value.label}
                    prefetch={false}
                  />
                </li>
              ) : (
                <li
                  className={className}
                  key={index}
                  onClick={() => {
                    handleClick(index);
                  }}
                  style={blockStyle}
                />
              )}
            </Tooltip>
          );
        })}
      </ul>
      {allColorCount > 3 ? (
        <span className='text-xs leading-[18px] text-80583F lg_text-sm lg_leading-5 lg_text-8B857D'>
          +{allColorCount}
        </span>
      ) : null}
    </div>
  );
};

export default CustomizeOptions;
